import { render, staticRenderFns } from "./SRA.vue?vue&type=template&id=3a20807b&scoped=true&"
import script from "./SRA.vue?vue&type=script&lang=js&"
export * from "./SRA.vue?vue&type=script&lang=js&"
import style0 from "./SRA.vue?vue&type=style&index=0&id=3a20807b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a20807b",
  null
  
)

export default component.exports